import { notifUtils } from "../components/NotifUtils/NotifUtils";
import { handleError } from "../components/Utils/Utils";
import ProductService from "../Services/ProductService/ProductService";

export const getList = (store, value, prevTabActive) => {
  const isLoading = !store.state.isLoading;
  const status = 200;
  store.setState({ isLoading, status });
  ProductService.getData(value)
    .then((response) => {
      let data = response.data;
      const isLoading = false;
      const status = data.message;
      store.state.data = data;
      store.setState({
        isLoading,
        header: response.headers,
        status,
      });
    })
    .catch((error) => {
      handleError(error);
    });
};

export const getListCurrated = (store, value, prevTabActive) => {
  const isLoading = !store.state.isLoading;
  const status = 200;
  store.setState({ isLoading, status });
  ProductService.GETcurrated(value)
    .then((response) => {
      // console.log(response.data);
      // console.log("0000000");
      const newRes = response.data.map((item) => {
        // console.log("ihza");
        return item.product;
      });
      // console.log(newRes);
      let data = response.data;
      const isLoading = false;
      const status = data.message;
      // store.state.data = data;
      store.state.alldata = response.data;
      store.setState({
        isLoading,
        header: response.headers,
        status,
      });
    })
    .catch((error) => {
      handleError(error);
    });
};
export const getListRecommendation = (store, value, prevTabActive) => {
  const isLoading = !store.state.isLoading;
  const status = 200;
  store.setState({ isLoading, status });
  ProductService.GETrecommendation(value)
    .then((response) => {
      console.log(response);
      console.log("0000000");
      const newRes = response.data.map((item) => {
        // console.log("ihza");
        return item.product;
      });
      // console.log(newRes);
      let data = response.data;
      const isLoading = false;
      const status = data.message;
      // store.state.data = data;
      store.state.alldata = response.data;
      store.setState({
        isLoading,
        header: response.headers,
        status,
      });
    })
    .catch((error) => {
      handleError(error);
    });
};

export const getDataProduct = async (store, query) => {
  ProductService.getDataProduct(query)
    .then((response) => {
      let data = response.data;
      store.setState({
        dataProduct: data,
      });
    })
    .catch((error) => {
      handleError(error);
      return error;
    });
};

export const getModulelist = (store) => {
  ProductService.getModule()
    .then((response) => {
      let data = response.data;
      store.setState({
        module: data,
      });
    })
    .catch((error) => {
      handleError(error);
    });
};

export const store = async (store, value) => {
  store.setState({ ...store.state, isSaving: true });
  return ProductService.storeData(value)
    .then((response) => {
      store.setState({ ...store.state, isSaving: false });
      notifUtils("Successfully Created Product", "success");
      return response.data;
    })
    .catch((error) => {
      store.setState({ ...store.state, isSaving: false });
      handleError(error);
      return error;
    });
};
export const storeCurrated = async (store, value) => {
  store.setState({ ...store.state, isSaving: true });
  return ProductService.currated(value)
    .then((response) => {
      store.setState({ ...store.state, isSaving: false });
      notifUtils("Successfully add Product", "success");
      return response.data;
    })
    .catch((error) => {
      store.setState({ ...store.state, isSaving: false });
      handleError(error);
      return error;
    });
};
export const storeRecommendation = async (store, value) => {
  store.setState({ ...store.state, isSaving: true });
  return ProductService.POSTrecommendation(value)
    .then((response) => {
      store.setState({ ...store.state, isSaving: false });
      notifUtils("Successfully add Product", "success");
      return response.data;
    })
    .catch((error) => {
      store.setState({ ...store.state, isSaving: false });
      handleError(error);
      return error;
    });
};

export const put = async (store, id, params) => {
  store.setState({ ...store.state, isSaving: true });
  return ProductService.put(id, params)
    .then((response) => {
      store.setState({ ...store.state, isSaving: false });
      notifUtils("Successfully Created Product", "success");
      return response.data;
    })
    .catch((error) => {
      store.setState({ ...store.state, isSaving: false });
      handleError(error);
      return error;
    });
};

export const patch = async (store, id, params, notif) => {
  try {
    const response = await ProductService.patch(id, params);
    const data = response.data;
    notifUtils(notif, "success");
    return data;
  } catch (error) {
    handleError(error);
    return error;
  }
};
export const bulkDelete = async (store, params, notif) => {
  try {
    const response = await ProductService.bulkDelete(params);
    const data = response.data;
    notifUtils(notif, "success");
    return data;
  } catch (error) {
    handleError(error);
    return error;
  }
};

export const deleted = async (store, id) => {
  try {
    await ProductService.delete(id);
    notifUtils("Successfully Remove Product", "success");
  } catch (error) {
    handleError(error);
    return error;
  }
};
export const deletedCurrated = async (store, id) => {
  try {
    await ProductService.deleteCurrated(id);
    notifUtils("Successfully Remove Product", "success");
  } catch (error) {
    handleError(error);
    return error;
  }
};
export const deleteRecommendation = async (store, id) => {
  try {
    await ProductService.deleteRecommendation(id);
    notifUtils("Successfully Remove Product", "success");
  } catch (error) {
    handleError(error);
    return error;
  }
};
